import { differenceInHours } from 'date-fns'

// Stories (Instagram / Facebook) vanish ~24h after posting, and their permalink
// dies with them.
export const STORY_LIFESPAN_HOURS = 24

export const EXPIRED_STORY_LINK_MESSAGE =
  'Stories expire after 24 hours, so this link no longer works'

/**
 * A sent Story whose ~24h lifespan has elapsed. Its permalink now 404s, so
 * callers disable the actions that hand that link to the user.
 */
export const isExpiredStory = ({
  postType,
  sentAt,
}: {
  postType: string | null | undefined
  sentAt: string | null | undefined
}): boolean => {
  if (postType !== 'story' || !sentAt) {
    return false
  }

  return differenceInHours(new Date(), new Date(sentAt)) >= STORY_LIFESPAN_HOURS
}
